import { Component, Injector, OnInit } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { deepCopy, getDataScopeByPermission, isNullOrEmpty, onDropdownKeydown } from 'src/app/core/utils/common-functions';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { OptionsMappingPipe } from 'src/app/shared/pipes/options-mapping.pipe';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { AddressServiceService } from 'src/app/core/services/address-service.service';

@Component({
  selector: 'laas-do-detail-for-shipping',
  templateUrl: './do-detail-for-shipping.component.html',
  styleUrls: ['./do-detail-for-shipping.component.scss'],
})
export class DoDetailForShippingComponent
  extends SessionBaseComponent
  implements OnInit
{
  doModel: any;
  readonly permissionCode: PermissionConstants =
    PermissionConstants.ViewQueryDo;
  readonly defaultSearchParams: any;
  searchParams: any;
  isShowEditBtn: boolean = true;
  isCancelEditBtn: boolean = false;
  isSaveEditBtn: boolean = false;
  editDeliveryTo: boolean = false;
  bookingForwarderOptions: any[];
  assignForwarderOptions: any[];
  facilityOptions: any[];
  letterHeadOptions: any[];
  billCorpOptions: any[];
  incoTermOptions: any[];
  DOStatusOptions: any[];
  priorityOptions: any[];
  orgIdList: any[];
  DOBookingStatusOptions: any[];
  tenantPermissionList: any[] = [];
  consigneeAddressOptions: any[] = [];

  assignForwarderCode: string = '';
  deliveryTo: string = '';
  deliveryToZip: string = '';
  deliveryToState: string = '';
  deliveryToProvince: string = '';
  deliveryToId: string = '';
  deliveryToCity: string = '';
  deliveryToCounty: string = '';
  deliveryToAddress1: string = '';
  deliveryToAddress2: string = '';
  deliveryToAddress3: string = '';
  deliveryToAddress4: string = '';

  protected readonly onDropdownKeydown = onDropdownKeydown;

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private dropdownOptionService: DropdownOptionsService,
    private facilityService: FacilityService,
    private addressService: AddressServiceService
  ) {
    super(injector);
    this.doModel = {};
    this.bookingForwarderOptions = [];
    this.assignForwarderOptions = [];
    this.facilityOptions = [];
    this.letterHeadOptions = [];
    this.billCorpOptions = [];
    this.incoTermOptions = [];
    this.DOStatusOptions = [];
    this.priorityOptions = [];
    this.orgIdList = [];
    this.DOBookingStatusOptions = [];
    this.defaultSearchParams = {
      doNos: [this.routeStateService.getCurrent()?.data?.doNo],
      tenants: [],
      letterHeadOrgIds: [],
      orgIds: [],
      shipCorps: [],
      consigneeKey: null,
      consigneeCompany: null,
      incoTerm: null,
      etdStart: null,
      etdEnd: null,
      deliveryType: null,
      dischargeType: null,
      invoiceDateStart: null,
      invoiceDateEnd: null,
      bookingCount: null,
      salesCode: [],
      status: [],
      doBookingStatus: null,
      isBookingNoExist: null,
      selectedFacility: [],
      isNoShippingReasonExist: null,
      bookingForwarder: [],
      dropType: null,
      invoiceNos: [],
      extraWorkStatus: null,
      mergeKeys: [],
      priority: null,
      taskCode: [],
      creater: [],
      consolidationIds: [],
      createDtMOStart: null,
      createDtMOEnd: null,
      sortOrders: null,
    };
    this.searchParams = deepCopy(this.defaultSearchParams);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    const params = deepCopy(this.searchParams);
    params.facility = this.laasSetting.facility;
    params.userLanguage = this.laasSetting.language;
    params.pageIndex = 0;
    params.pageSize = 5;
    params.dataScopes = getDataScopeByPermission(
      this.userProfile,
      this.permissionCode
    );
    params.statuses = isNullOrEmpty(params.status) ? [] : params.status;
    params.etdStart = isNullOrEmpty(params.etdStart)
      ? null
      : new Date(params.etdStart).toISOString();
    params.etdEnd = isNullOrEmpty(params.etdEnd)
      ? null
      : new Date(params.etdEnd).toISOString();
    params.invoiceDateStart = isNullOrEmpty(params.invoiceDateStart)
      ? null
      : new Date(params.invoiceDateStart).toISOString();
    params.invoiceDateEnd = isNullOrEmpty(params.invoiceDateEnd)
      ? null
      : new Date(params.invoiceDateEnd).toISOString();

    params.createDtMOStart = isNullOrEmpty(params.createDtMOStart)
      ? null
      : new Date(params.createDtMOStart).toISOString();

    params.createDtMOEnd = isNullOrEmpty(params.createDtMOEnd)
      ? null
      : new Date(params.createDtMOEnd).toISOString();

    this.DOService.getDeliveryOrdersForShipping(params).subscribe({
      next: (result) => {
        this.doModel = result.content[0];
        this.assignForwarderCode = result.content[0].assignForwarder;
      },
    });

    this.dropdownOptionService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.bookingForwarderOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.facilityService
      .getForwarderOptions(this.laasSetting.facility)
      .subscribe({
        next: (result) => {
          this.assignForwarderOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionCode}-${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        },
      });

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDOBookingStatusOptions().subscribe({
      next: (options: any[]) => {
        this.DOBookingStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getPriorityOptions().subscribe({
      next: (options: any[]) => {
        this.priorityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService
      .getLetterOrgOptions(this.doModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.letterHeadOptions = options.map((x) => ({
            label: x.legalEntityOUName,
            value: x.legalEntityOUCode,
          }));
          this.billCorpOptions = options.map((x) => ({
            label: x.billOUName,
            value: x.billOUCode,
          }));
          this.orgIdList = options.map((x) => ({
            label: `${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          }));
        },
      });

    this.dropdownOptionService.getIncoTermOptions().subscribe({
      next: (options: any[]) => {
        this.incoTermOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getDOStatusOptions().subscribe({
      next: (options: any[]) => {
        this.DOStatusOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.DOService.getDOTenantPermission()
    .subscribe({
      next: (appCsmSettingBean: any) => {
        if (!appCsmSettingBean || !appCsmSettingBean.appCsmSettingDetailList || appCsmSettingBean.appCsmSettingDetailList.length === 0) {
          return;
        }
        for (let appCsmSettingDetail of appCsmSettingBean.appCsmSettingDetailList) {
          if (appCsmSettingDetail?.tenant) {
            this.tenantPermissionList.push(appCsmSettingDetail.tenant);
          }
        }
      }
    });
  }

  editBtnClick(event: any): void {
    this.isShowEditBtn = false;
    this.isCancelEditBtn = true;
    this.isSaveEditBtn = true;

    if(this.tenantPermissionList.includes(this.doModel.tenant)){
      this.editDeliveryTo = true;
    }

    this.addressService.getConsigneeReferenAddress(this.doModel.consigneeKey).subscribe({
      next: (options: any[]) => {
        this.consigneeAddressOptions = options.map(x => ({
          label: x.address,
          value: x.groupId,
        }));
      }
    });

  }

  saveBtnClick(event: any): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('Common.Confirm.Header'),
      message: this.translateService.instant('Common.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.isShowEditBtn = true;
        this.isCancelEditBtn = false;
        this.isSaveEditBtn = false;
        this.editDeliveryTo = false;


        if (this.assignForwarderCode != this.doModel?.assignForwarder && this.assignForwarderCode !== null && this.assignForwarderCode !== undefined && this.assignForwarderCode.trim() !== "") {
          this.updateAssignForwarderCode(this.assignForwarderCode);
        }

        if(this.deliveryTo !=  this.doModel?.deliveryToAddress && this.deliveryTo !== null && this.deliveryTo !== undefined && this.deliveryTo && this.deliveryTo.trim() !== ""){
          this.updateDeliveryToCode(
            this.doModel.deliveryToZip,
            this.doModel.deliveryToState,
            this.doModel.deliveryToProvince,
            this.doModel.deliveryToId,
            this.doModel.deliveryToCity,
            this.doModel.deliveryToCounty,
            this.doModel.deliveryToAddress1,
            this.doModel.deliveryToAddress2,
            this.doModel.deliveryToAddress3,
            this.doModel.deliveryToAddress4
          );
        }

        setTimeout(() => {
          location.reload();
        }, 1500);
      },
    });
  }

  cancelBtnClick(event: any): void {
    this.isShowEditBtn = true;
    this.isCancelEditBtn = false;
    this.isSaveEditBtn = false;
    this.editDeliveryTo = false;
    setTimeout(() => {
      location.reload();
    }, 500);
  }

  updateAssignForwarderCode(assignForwarderCode: any) {
    let uuid = '';
    const characters = 'abcdef0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < 32; i++) {
      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-';
      }
      uuid += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    const request = {doChangeBeanList:[{
      rowId: uuid,
      changeType: 'forwarder',
      doNo: this.doModel?.doNo,
      forwarderCode: assignForwarderCode,
      lastUpdatedBy: this.userProfile.userName,
      lastUpdateDate: new Date(),
    }]};
    this.DOService.updateDOChangeForCommon(request).subscribe({
      next: (result) => {
        this.toastService.info('貨代儲存成功');
      },
      error: (err) => {
        this.toastErrorMessage(err.error);
      },
    });
  }

  updateDeliveryToCode(
    deliveryToZip: any,
    deliveryToState: any,
    deliveryToProvince: any,
    deliveryToId: any,
    deliveryToCity: any,
    deliveryToCounty: any,
    deliveryToAddress1: any,
    deliveryToAddress2: any,
    deliveryToAddress3: any,
    deliveryToAddress4: any
  ) {
    let uuid = '';
    const characters = 'abcdef0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < 32; i++) {
      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-';
      }
      uuid += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    const valueToFind = this.deliveryTo;
    const label = this.findLabelByValue(valueToFind);

    const request = {doChangeBeanList:[
      {
        changeType: "normalizationGroupId",
        doNo: this.doModel?.doNo,
        lastUpdatedBy: this.userProfile?.userName,
        rowId: uuid,
        normalizationGroupId: valueToFind
      },
      {
        changeType: "deliveryTo",
        doNo: this.doModel?.doNo,
        lastUpdatedBy: this.userProfile?.userName,
        rowId: uuid,
        deliveryToAddress1: deliveryToAddress1,
        deliveryToAddress2: label,
        deliveryToCity: deliveryToCity,
        deliveryToCounty: deliveryToCounty,
        deliveryToId: deliveryToId,
        deliveryToProvince: deliveryToProvince,
        deliveryToState: deliveryToState,
        deliveryToZip: deliveryToZip,
      }
    ]};
    setTimeout(() => {
      this.DOService.updateDOChangeForCommon(request).subscribe({
        next: (result) => {
          this.toastService.info('地址儲存成功');
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        },
      });
    }, 500);
  }

  onChange(){
    if (this.consigneeAddressOptions) {

    }
  }

  findLabelByValue(valueToFind: any): string | undefined {
    const matchingOption = this.consigneeAddressOptions.find(option => option.value === valueToFind);
    return matchingOption ? matchingOption.label : undefined;
  }
}



